<template>
  <div class="no-data-wrapper">
    <!-- hideWhenNoDataの制御をslotにのみ適用 -->
    <slot v-if="hasData || !hideWhenNoData" />
    <!-- マスクは常に hasData の状態のみで制御 -->
    <div v-if="!hasData" class="no-data-mask">
      <div class="no-data-message">
        {{ message || $t('no_data') }}
      </div>
    </div>
  </div>
</template>

<i18n lang="yaml">
ja:
  no_data: 'データなし'
en:
  no_data: 'No Data'
</i18n>

<script>
export default {
  name: 'no-data-wrapper',
  props: {
    hasData: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      default: null,
    },
    hideWhenNoData: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="sass">
.no-data-wrapper
  position: relative

.no-data-mask
  position: absolute
  top: 0
  left: 0
  right: 0
  bottom: 0
  display: flex
  align-items: center
  justify-content: center
  background-color: rgba(255, 255, 255, 0.5)
  z-index: 1

.no-data-message
  font-size: 1.5rem
  color: #666
  font-weight: 500
</style>
